<template>
    <div class="fxn-padding-t-20">
        <!-- Tabs -->
        <div class="fxn-tabs fxn-margin-t-20">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="调解记录" name="1"></el-tab-pane>
                <el-tab-pane label="回款记录" name="2"></el-tab-pane>
                <el-tab-pane label="减免记录" name="3"></el-tab-pane>
            </el-tabs>
        </div>
        <!-- Tabs End -->

        <!-- 调解记录 -->
        <div class="fxn-margin-16-0" v-show="activeName == '1'">
            <el-table v-loading="loading" :data="notes" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                <el-table-column label="调解记录时间" align="center" width="170">
                    <template slot-scope="scope">
                        {{scope.row.add_time | dateTime('1')}}
                    </template>
                </el-table-column>
                <el-table-column label="联络人" align="center">
                    <template slot-scope="scope">
                        {{scope.row.contacts_name}}
                        ({{scope.row.relation}})
                    </template>
                </el-table-column>
                <el-table-column label="联络方式" align="center" width="120">
                    <template slot-scope="scope">
                        {{scope.row.contacts_phone_all | mobile}}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="跟进状态" align="center" :formatter="ChangeStatus"></el-table-column>
                <el-table-column prop="coll_status" label="调解状态" align="center" :formatter="ChangeColl"></el-table-column>
                <el-table-column prop="notes" label="沟通内容" align="center"></el-table-column>
                <el-table-column prop="notes" label="承诺还款信息/备注" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sms_repay_count">
                            <el-button class="fxn-text-blue" type="text" @click="getSmsRepay(scope.row.id)">接收方短信回复</el-button>
                        </div>
                        <span v-else-if="scope.row.status == 2">
                            <span v-if="scope.row.coll_status == 1">
                                承诺在{{scope.row.promise_time | dateTime}}前还款{{scope.row.promise_money}}元
                            </span>
                            <span v-else-if="scope.row.coll_status == 3">
                                承诺分{{scope.row.promise_periods}}还款，{{scope.row.promise_per_day}}还{{scope.row.promise_per_money}}”
                            </span>
                            <span v-else-if="scope.row.coll_status == 4">
                                另约{{scope.row.order_time | dateTime(1)}}进行沟通
                            </span>
                            <span v-else>--</span>
                        </span>
                        <span v-else-if="scope.row.status == 8">
                            <span v-if="scope.row.repay_status == 2">{{scope.row.repay_time | dateTime}}部分还款{{scope.row.repay_money}}元</span>
                            <span v-else>--</span>
                        </span>
                        <span v-else-if="scope.row.status == 9">
                            <span v-if="scope.row.repay_status == 2">{{scope.row.repay_time | dateTime}}结清还款{{scope.row.repay_money}}元</span>
                            <span v-else>--</span>
                        </span>
                        <span v-else>
                            --
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="add_name" label="调解员" align="center"></el-table-column>
                <el-table-column prop="contact_channel" label="联系渠道" align="center" :formatter="ChangeChannel"></el-table-column>
            </el-table>
        </div>
        <!-- 调解记录 End -->

        <!-- 回款记录 -->
        <div class="fxn-margin-16-0" v-show="activeName == '2'">
            <div class="fxn-margin-16-0">
                <el-select v-model="tostatus" placeholder="请选择" @change="onRepay">
                    <el-option v-for="item in reStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div>终审通过还款金额合计：{{repay_total | toThousands}}元</div>

            <el-table v-loading="loading" :data="repayments" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                <el-table-column label="登记时间" align="center" width="170">
                    <template slot-scope="scope">
                        {{scope.row.add_time | dateTime('1')}}
                    </template>
                </el-table-column>
                <el-table-column label="还款时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.repay_time | dateTime}}
                    </template>
                </el-table-column>
                <el-table-column prop="repay_money" label="还款金额" align="center">
                    <template slot-scope="{ row }">
                        {{ row.repay_money | toThousands }}
                    </template>
                </el-table-column>
                <el-table-column prop="repay_channel" label="还款方式" align="center"></el-table-column>
                <el-table-column label="订单号/还款卡号" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.repay_channel == '银联还款'">
                            {{scope.row.repay_account}}
                            <span v-if="scope.row.repay_account1">**** {{scope.row.repay_account1}}</span>
                        </span>
                        <span v-else>
                            {{scope.row.repay_orderno}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="repay_account_name" label="转账人姓名" align="center"></el-table-column>
                <el-table-column prop="repay_status" label="还款类型" align="center" :formatter="changeRepay"></el-table-column>
                <el-table-column label="审核状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.repaystatus != 3">{{RepaymentStatus(scope.row.repaystatus,scope.row.hexiao)}}</span>
                        <el-popover v-if="scope.row.repaystatus == 3" title="拒绝原因：" placement="top-start" width="200" trigger="hover" :content="scope.row.verify_remark">
                            <el-button type="text" slot="reference">{{RepaymentStatus(scope.row.repaystatus)}}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" @click="OpenDetail(scope.row.repay_voucher)">查看还款凭证</el-button>
                        <el-popover v-if="scope.row.verify_remark != ''" title="查看原因" placement="top-start" width="200" trigger="hover" :content="VerifyRepay(scope.row.verify_fail) + '：' + scope.row.verify_remark">
                            <el-button type="text" slot="reference">查看原因</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 回款记录 End -->

        <!-- 减免记录 -->
        <div class="fxn-margin-16-0" v-show="activeName == '3'">
            <el-table v-loading="loading" :data="agios" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                <el-table-column label="申请时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.add_time | dateTime('1')}}
                    </template>
                </el-table-column>
                <el-table-column prop="add_name" label="申请人" align="center"></el-table-column>
                <el-table-column prop="reason" label="申请原因" align="center"></el-table-column>
                <el-table-column prop="agio_money" label="减免后金额" align="center">
                    <template slot-scope="{ row }">
                        {{ row.agio_money | toThousands }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="申请状态" align="center" :formatter="ChangeAgioStatus"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-popover v-if="scope.row.verify_remark != '' && (scope.row.status == 3 || scope.row.status == 5 || scope.row.status == 6)" title="查看原因" placement="top-start" width="200" trigger="hover" :content="VerifyFail(scope.row.verify_fail) + '：' + scope.row.verify_remark">
                            <el-button type="text" slot="reference">查看原因</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 减免记录 End -->

        <!-- 查看还款凭证 -->
        <el-dialog title="查看还款凭证" :visible.sync="dialogVisible" width="50%" append-to-body>
            <el-carousel indicator-position="outside">
                <el-carousel-item v-for="(item,index) in PayMentImg" :key="index" class="fxn-text-center">
                    <img :src="TextUrl + item" alt="" srcset="" style="max-width: 100%;max-height: 100%">
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
        <!-- 查看还款凭证 End -->

        <!-- 接收方短信回复 -->
        <SmsRepay :smsRepayObj="smsRepayObj"></SmsRepay>
        <!-- 接收方短信回复 END -->
    </div>
</template>

<script>
    import SmsRepay from '../../components/SmsRepay'
    export default {
        components:{
            SmsRepay
        },
        props: {
            SipPop: {
                type: Object
            }
        },
        data(){
            return{
                loading: false,
                notes: [],
                repayments: [],
                agios: [],
                contactChannel: [],
                CollStatus: [],
                StatusData: [
                    {value: 1, label: '待跟进'},
                    {value: 2, label: '重点跟进'},
                    {value: 3, label: '承诺还款'},
                    {value: 4, label: '失联跟进'},
                    {value: 5, label: '每日跟进'},
                    {value: 6, label: '沟通无果'},
                    {value: 7, label: '难联户'},
                    {value: 8, label: '部分还款'},
                    {value: 9, label: '结清还款'},
                    {value: 10, label: '申请发函'},
                    {value: 11, label: '发送短信'},
                    {value: 12, label: '发送邮件'},
                    {value: 99, label: '特殊状态'},
                ],

                //Tabs
                activeName: '1',

                //回款记录
                repay_total: '',
                tostatus: '',
                reStatus: [],
                
                //凭证阅览
                PayMentImg: [],
                dialogVisible: false,

                //接收方短信回复
                smsRepayObj: {
                    SmsRepayWin: false,
                    SmsRepayData: [],
                    Smsloading: false,
                },
            }
        },
        methods:{
            //Tabs
            handleClick(){
                this.getWorks();
            },

            //选择回款记录
            onRepay(){
                this.getWorks(this.tostatus);
            },

            //获取Tabs
            getWorks(status){
                this.loading = true;
                this.get('/osapi/Cases/caseWork',{
                    case_id: this.SipPop.case_id,
                    work_type: this.activeName,
                    status: status
                })
                .then(res=>{
                    let { code  , msg ,data} = res.data
                    if( code != 1){
                        this.$message({
                            message:msg,
                            type:'error'
                        })
                    }else{
                        this.notes = res.data.data.notes;
                        this.repayments = res.data.data.repayments;
                        this.agios = res.data.data.agios;
                        this.repay_total = res.data.data.repay_total;
                    }
                    this.loading = false;
                })
            },

            //接收方短信回复
            getSmsRepay(id) {
                this.get('/osapi/Cases/getCaseNotesSmsRepay',{
                    note_id: id
                }).then( res => {
                    let { code , msg , data } = res.data;
                    if (code != 1) {
                        this.$message({
                            type: 'error',
                            message: msg
                        })
                        this.smsRepayObj.Smsloading = false;
                    } else {
                        this.smsRepayObj.SmsRepayWin = true;
                        this.smsRepayObj.SmsRepayData = res.data.data.sms_repay_list;
                        this.smsRepayObj.Smsloading = false;
                    }
                })
            },

            //获取渠道
            getConfigList(){
                this.get('/osapi/Config/confList')
                .then( res => {
                    let { msg, code, data } = res.data
                    if( code !== 1 ){
                        this.$message({
                            message : msg,
                            type: 'error'
                        })
                    }else{
                        this.contactChannel = res.data.data;
                        if(this.contactChannel.length < 1){
                            this.$message({
                                message: '请先添加联系渠道!',
                                type: 'error'
                            }); 
                            return false;
                        }
                    }
                })
            },

            //查看
            OpenDetail(repay_voucher){
                this.dialogVisible = true;
                this.PayMentImg = repay_voucher.split(',')
            },

            //跟进状态
            ChangeStatus(row){
                for (let index = 0; index < this.StatusData.length; index++) {
                    if(row.status == this.StatusData[index].value){
                        return this.StatusData[index].label;
                    }
                }
            },

            //调解状态
            ChangeColl(row){
                for(let key in this.CollStatus){
                    if(row.coll_status == key){
                        return this.CollStatus[key]
                    }
                }
            },

            //联系渠道
            ChangeChannel(row){
                for(let key in this.contactChannel){
                    if(row.contact_channel == this.contactChannel[key].id){
                        return this.contactChannel[key].title;
                    }
                }
            },

            //还款类型
            changeRepay(row){
                switch(parseInt(row.repay_status)){
                    case 8:
                        return '部分还款'
                    case 9:
                        return '结清还款'
                }
            },

            //减免状态
            ChangeAgioStatus(row){
                switch(parseInt(row.status)){
                    case 1:
                        return '未处理'
                    case 2:
                        return '通过'
                    case 3:
                        return '拒绝'
                    case 4:
                        return '待终审'
                    case 5:
                        return '拒绝'
                }
            },

            //减免--拒绝原因状态
            VerifyFail(type){
                switch(parseInt(type)){
                    case 1:
                        return '超过减免比例'
                    case 2:
                        return '减免资料缺失'
                    case 3:
                        return '减免资料错误'
                    case 4:
                        return '金额错误'
                    case 5:
                        return '拒绝'
                    case 6:
                        return '结清还款时提交申请'
                }
            },

            //回款记录--审核状态
            RepaymentStatus(repaystatus,hexiao){
                if(repaystatus == 1){
                    return '待审核'
                }else if(repaystatus == 2){
                    if(hexiao == 1){
                        return '核销通过'
                    }else{
                        return '已通过'
                    }                    
                }else if(repaystatus == 3){
                    return '初审不通过'
                }else if(repaystatus == 4){
                    return '初审通过'
                }else if(repaystatus == 5){
                    return '终审不通过'
                }else if(repaystatus == 6){
                    return '已撤销'
                }
            },

            //回款拒绝原因
            VerifyRepay(type){
                if(type ==1 ){
                    return '无凭证'
                }else if(type ==2){
                    return '凭证错误'
                }else if(type == 3){
                    return '未收到'
                }
            },
        },
        mounted(){
            this.getWorks();
            this.getConfigList();

            //获取催记状态
            this.CollStatus = JSON.parse(sessionStorage.getItem('noteLinkage'));
        }
    }
</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/AiSip/CallTabs.vue